/**
 * Path predicates for the Clerk middleware in proxy.ts.
 * Replaces Clerk's deprecated createRouteMatcher with the same semantics:
 * a "(.*)"-suffixed pattern matched the path itself plus any continuation,
 * which is exactly String.startsWith; patterns without "(.*)" were exact.
 * Pure module — no imports — so the middleware stays edge-safe and the
 * predicates stay unit-testable.
 */

const UNPROTECTED_PREFIXES = [
  "/sign-in",
  "/sign-up",
  "/api/v1/webhooks",
  // A liveness probe that requires a login is not a liveness probe: this used
  // to 307 an anonymous caller to /landing, so nothing outside the app could
  // ever read it. Needed by TX-4910, which keeps it up during maintenance.
  "/api/health",
  "/api/chat-attachment",
  "/accept-token",
  "/sso-google-callback",
  "/landing",
  "/cartoons",
  "/p/", // Vanity URLs for affinities
  "/error",
] as const;

const UNPROTECTED_EXACT = ["/api/uploadthing"] as const;

export function isUnprotectedPath(pathname: string): boolean {
  return (
    UNPROTECTED_EXACT.some((path) => pathname === path) ||
    UNPROTECTED_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}

/** API routes that authenticate themselves (Hono requireAuth middleware). */
export function isApiWithOwnAuthPath(pathname: string): boolean {
  return pathname.startsWith("/api/v1/");
}

export function isAdminPath(pathname: string): boolean {
  return pathname.startsWith("/admin");
}
